import { Component, Inject, Injector, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseComponent } from 'src/app/common/base/base.component';
import { RSFSettings, RSFSettingType } from './rsf-settings';
import { RsfSettingsService } from './rsf-settings.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'rsf-settings',
  templateUrl: './rsf-settings.component.html',
  styleUrls: ['./rsf-settings.component.scss']
})
export class RsfSettingsComponent extends BaseComponent implements OnInit, OnDestroy {

  loading?: boolean;

  rsfSettings?: RSFSettings[];
  rsfSettingsSubs!: Subscription;

  rsfSettingsType = RSFSettingType;

  constructor(
    protected override injector: Injector,
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private dialogRef: MatDialogRef<RsfSettingsComponent>,
    private service: RsfSettingsService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.loadRSFSettingss();
  }

  override ngOnDestroy(): void {
    this.rsfSettingsSubs?.unsubscribe();
  }

  loadRSFSettingss() {
    this.rsfSettingsSubs = this.store.select(state => state.RSFSettings.data).subscribe(data => {
      if (data?.length) {
        this.rsfSettings = data;
      }
    });
  }

  async close() {
    if (await this.canDeactivate()) {
      this.dialogRef.close();
    }
  }

  saveChanges(settings: RSFSettings[], type: RSFSettingType) {
    if (!this.rsfSettings) this.rsfSettings = [];
    this.rsfSettings = this.rsfSettings?.filter(s => s.type != type).concat(settings) ?? [];
    this.setFormDirty();
  }

  save() {
    if (this.rsfSettings)
      this.service.save(this.rsfSettings).toPromise().then(() => {
        this.alert.success('Settings Saved!');
        this.setFormDirty(false);
      }).catch(error => {
        console.error(error);
        this.alert.defaultError();
      });

  }
}
